const initialValues = {
    type: false,
    sum: 20000,
    percent: 12,
    mounth: 6
}

export { initialValues }